import { FC } from 'react';
import { IconT } from 'shared/assets/icons';
import styles from './styles.module.scss';

interface LogoProps {
    className?: string;
    cropToMark?: boolean;
}

export const Logo: FC<LogoProps> = ({ className, cropToMark = false }) => {
    return (
        <div className={`${styles.logo} ${className || ''}`}>
            <IconT {...(cropToMark ? { viewBox: '0 11 60 38' } : {})} aria-hidden="true" />
        </div>
    );
};
